import { useLenis } from "lenis/react";
import { createContext, useEffect, useState } from "react";


export const NavbarContext = createContext(false);

export const NavbarProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const lenis = useLenis();

    useEffect(() => {
        if (isOpen) {
            lenis?.stop();
        } else {
            lenis?.start();
        }
    }, [isOpen, lenis]);
  
    return (
        <NavbarContext.Provider value={{isOpen, setIsOpen}}>
            { children }
        </NavbarContext.Provider>
    )
} 